import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import ComponentLayout from '~/src/layouts/component-layout';
import { Link, Text } from '@primer/react';
import { Link as GatsbyLink } from 'gatsby';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <Note variant="warning" mdxType="Note">
  <Text sx={{
        display: 'block',
        fontWeight: 'bold',
        mb: 2
      }} mdxType="Text">Usage for this component is not encouraged</Text>
  <Text mdxType="Text">Instead, please see <Link as={GatsbyLink} to="/components/action-menu" mdxType="Link">action menu</Link> or <Link as={GatsbyLink} to="/components/selectpanel" mdxType="Link">select panel</Link>.</Text>
    </Note>
    <p>{`Select menu is only available right now as a `}<a parentName="p" {...{
        "href": "/deprecated-components/select-menu/css"
      }}>{`CSS component`}</a>{`. Select menu can make use of JavaScript-enabled live filtering, selected states, tabbed lists, and keyboard navigation with a bit of markup. To see all examples of this component, view it in the `}<a parentName="p" {...{
        "href": "https://primer.style/css/storybook/?path=/docs/deprecated-selectmenu--docs"
      }}>{`Primer CSS storybook`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      